import React from "react";
import { sortByQuestionOrder } from "../../helpers/sortByQuestionOrder";

import { Grid } from "../../UI/Grid";
import { SliderQuestion } from "./SliderQuestion";
import { ISliderQuestion } from "../../constants/types";

interface IProps {
  questions?: ISliderQuestion[];
  height?: number;
}

export const UserSliderQuestions: React.FC<IProps> = (props) => (
  <Grid container>
    {sortByQuestionOrder(props.questions as ISliderQuestion[]).map((question: any) => (
      <Grid
        item
        xs={12}
        px={3}
        key={question.questionId}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        <SliderQuestion {...question} height={props.height} />
      </Grid>
    ))}
  </Grid>
);

UserSliderQuestions.defaultProps = {
  questions: [],
};
